import { Field, FieldType } from '../types';

export const checkBlockElement = (fields: Field[]) =>
  fields.reduce(
    (accumulate, nextField) => accumulate + (nextField.type === FieldType.ATTACHMENT ? 2 : 1),
    0
  ) %
    2 !==
  0;
